import { useCallback } from 'react';
import { useSnapshot } from 'valtio';

import { getHomepageUrl } from '@cartwhl/common/utils';
import Text from '@cartwhl/ui/base/Text';
import Button from '@cartwhl/ui/input/Button';
import Modal from '@cartwhl/ui/molecules/Modal';

import { userStore } from 'stores/global';

const PLAN_BILLING_URL = getHomepageUrl('/pricing');
const SUPPORT_ADVANCED_MAILTO =
  'mailto:pros@getcartwheel.com?subject=Switch%20to%20an%20Advanced%20plan';

export default function BatchFeatureUpgradeModal({
  open,
  onDismiss,
}: {
  open: boolean;
  onDismiss: () => void;
}) {
  const { userInfo } = useSnapshot(userStore.state);
  const isLegacyUnlimitedPlan = userInfo.planType === 'unlimited';

  const handleOpenChange = useCallback(
    (next: boolean) => {
      if (!next) onDismiss();
    },
    [onDismiss],
  );

  if (isLegacyUnlimitedPlan) {
    return (
      <Modal
        open={open}
        onOpenChange={handleOpenChange}
        title="Not available on Unlimited"
        description="Unlimited plans are not eligible to use this feature. Reach out to support (pros@getcartwheel.com) to learn about switching your account to an Advanced plan."
        maxWidth={480}
        footer={
          <div className="flex flex-wrap items-center justify-end gap-3">
            <Button variant="secondary" type="button" onClick={onDismiss}>
              Dismiss
            </Button>
            <a
              href={SUPPORT_ADVANCED_MAILTO}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button variant="primary" type="button">
                Contact support
              </Button>
            </a>
          </div>
        }
      >
        <></>
      </Modal>
    );
  }

  return (
    <Modal
      open={open}
      onOpenChange={handleOpenChange}
      title="Upgrade required"
      description="Upgrade your account to unlock access to this feature."
      maxWidth={480}
      footer={
        <div className="flex flex-wrap items-center justify-between gap-3">
          <Button variant="secondary" type="button" onClick={onDismiss}>
            Dismiss
          </Button>
          <a href={PLAN_BILLING_URL}>
            <Button variant="primary" type="button">
              Upgrade account
            </Button>
          </a>
        </div>
      }
    >
      <></>
    </Modal>
  );
}
